import type { ElementType } from 'react';
import { Stack } from '@mui/material';

export const FilledIcon = ({ icon: IconComponent }: { icon: ElementType }) => (
  <Stack
    alignItems="center"
    justifyContent="center"
    bgcolor="primary.dark"
    sx={{ width: 34, height: 34 }}
  >
    <IconComponent sx={{ color: 'white' }} />
  </Stack>
);
